import { installDataLayerLogger } from "./dataLayerProxy";
if (process.env.LOCALHOST) {
    installDataLayerLogger(); // or installDataLayerLogger({ prefix: '[GTM]' });
}

export const checkObject = (obj) =>
    Object.keys(obj).length > 0 ? true : false;

export const getUrlParameterByKey = (key) => {
    const urlQueryParameters = window.location.search;
    const regExp = !key
        ? new RegExp("[a-z0-9-!=+]+", "ig")
        : new RegExp(`${key}=([a-z0-9-!+%20;]+)`, "i");

    if (key && urlQueryParameters.match(regExp)) {
        return urlQueryParameters
            .match(regExp)[1]
            .replace(new RegExp("%20", "g"), " ");
    }

    return null;
};

export const setUrlParameter = (key, val) => {
    if (history.pushState && key && val) {
        const url = window.location.href;
        const regExp = new RegExp("([?&])" + key + "[^&]*");
        const newParam = key + "=" + val;
        let newUrl = url;

        if (url.match(regExp)) {
            newUrl = url.replace(regExp, "$1" + newParam);
        } else if (url.indexOf("?") !== -1) {
            newUrl = url + "&" + key + "=" + val;
        } else {
            newUrl = url + "?" + key + "=" + val;
        }

        window.history.pushState({ path: newUrl }, "", newUrl);
    }
};

/**
 * Returns the normalised URL to use for tracking:
 * absolute URL for external links,
 * or root-relative, without the origin/domain for same-origin links.
 * @param {string} url - The URL to normalise
 * @returns {string|null} - The normalised URL, or null if not valid
 */
export const getNormalisedUrl = (url) => {
    try {
        const linkUrlObj = new URL(url);
        const currentUrlObj = new URL(window.location.href);
        if (linkUrlObj.origin === currentUrlObj.origin) {
            return linkUrlObj.href.replace(linkUrlObj.origin, "");
        }
        return linkUrlObj.href;
    } catch {
        return url || null;
    }
};

/**
 * Returns the URL to use for tracking: full href for external links,
 * or only the pathname for same-origin links.
 * @param {HTMLAnchorElement} linkEl - The link element (must have .href)
 * @returns {string|null} - The href or pathname, or null if no valid link
 */
export const getTrackingUrlFromElement = (linkEl) => {
    if (!linkEl || !linkEl.href) return null;
    return getNormalisedUrl(linkEl.href);
};

// helper for getting the link on a container element and adding to gtm
export const basicLinkTracker = (elementClass, componentName) => {
    const element = document.querySelector(elementClass);
    if (!element) return;

    element.addEventListener("click", (e) => {
        const { target } = e;
        if (target.nodeName !== "A") return;
        const linkText = target.textContent.trim() || "";
        const cleanText = linkText.replace(/\\/g, ""); // removes backslashes
        const linkUrl = target.getAttribute("href") || "";

        gtmPush({
            event: "interaction_click",
            component_name: componentName,
            click_text: cleanText,
            click_url: getNormalisedUrl(linkUrl),
        });
    });
};

/**
 * Push events into gtm Data la
 */
export const gtmPush = (event = null, url = "") => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);

    // redirect if click_url is present
    if (url) {
        window.location = url;
    }
};

/**
 * Navigation Helper Function
 */

export const navigationClickTracking = (
    clickText,
    clickUrl = null,
    navLevel = 1,
    navState = null,
) => {
    const eventData = {
        event: "navigation_click",
        navigation_type: "main_nav",
        click_text: clickText,
        click_url: clickUrl,
        nav_level: navLevel,
    };

    // Only add nav_state if provided
    if (navState !== null) {
        eventData.nav_state = navState;
    }

    gtmPush(eventData);
};

// Domains to check
export const DOMAINS_RE = new RegExp(
    /squiz\.(net|cloud)|(?<!my)tac\.vic\.gov\.au/,
);

// get relative paths
export const relativePath = (url) => {
    if (!url) {
        return undefined;
    }

    // if not a valid url, return the url
    let urlObj;
    try {
        urlObj = new URL(url);
    } catch (e) {
        return url;
    }
    const isOurDomain = DOMAINS_RE.test(urlObj.hostname);

    if (/^http/.test(url) && !isOurDomain) {
        return url;
    }

    return urlObj.pathname;
};
